module.exports = __webpack_public_path__ + "static/media/ablaviation.61f151f4.png";